module.exports = __webpack_public_path__ + "static/img/li6_1.1ad8c592.png";